import React, { type FunctionComponent, useCallback } from 'react'
import { Checkbox } from '@retailer-platform/shared-components'
import { type ProductsSearchDatum } from 'domains/products/components/search/utils/types'
import { useSelectionManager } from 'utils/selection-manager/SelectionManager'

type Props = Pick<ProductsSearchDatum, 'productId'>

export const ProductsSearchTableSelectionCell: FunctionComponent<Props> = ({ productId }) => {
  const { isSelected, setSelected, isGlobalSelection } = useSelectionManager()

  const onChange = useCallback(
    ({ currentTarget }: React.FormEvent<HTMLInputElement>) => {
      setSelected(productId, currentTarget.checked)
    },
    [productId, setSelected]
  )

  return (
    <div>
      <Checkbox
        data-testid="product-search-table-selection-checkbox"
        checked={isSelected(productId)}
        onChange={onChange}
        disabled={isGlobalSelection}
      />
    </div>
  )
}
